import { FaInfoCircle } from 'react-icons/fa'
import { MdAddPhotoAlternate } from 'react-icons/md'
import { Link } from 'react-router-dom'

import { usePermission } from '../hooks/usePermission'
import { ProductProblem, productProblemsMap } from '../interfaces/productProblemsEnum'
import { Report } from '../services/reportServices'
import { formatDateRelativeTime } from '../utils/formatDateRelativeTime'
import { Badge } from './Badge'
import { Button } from './Button'
import { ImagesCarousel } from './ImagesCarousel'

interface ReportCardProps {
  report: Report
  onAddImagesClick: (report: Report) => void
}

export function ReportCard({ report, onAddImagesClick }: ReportCardProps) {
  const permissions = usePermission()

  function defineAlertBadges() {
    const getPoductBadgeTitle = (values: ProductProblem[]) => {
      const problems: string[] = []
      values.forEach(item => {
        if (!problems.includes(productProblemsMap[item])) {
          problems.push(productProblemsMap[item])
        }
      })

      return problems.join(' - ')
    }

    if (report.report_product_problem.length === 0 && !report.has_promoter_problem) {
      return (
        <Badge status={false} title="Tudo ok" />
      )
    } else {
      return (
        <>
          {report.has_promoter_problem &&
            <Badge status={report.has_promoter_problem} title="Promotor" />}
          {report.report_product_problem.length > 0 &&
            <Badge
              status={report.report_product_problem.length > 0}
              title={getPoductBadgeTitle(report.report_product_problem.map(item => item.problem))}
            />}
        </>
      )
    }
  }

  return (
    <div className="flex flex-col border rounded-sm bg-white shadow-sm">
      <header className="flex justify-between items-stretch p-4">
        <div className="flex flex-col">
          <Link to={`/reports/${report.id}`} className="flex flex-row gap-2">
            <img
              src={report.store.group.logo_url}
              className="w-6 h-6 md:w-8 md:h-8 object-cover rounded-md border"
            />
            <strong className="text-lg md:text-2xl text-slate-900">
              {report.store.name}
            </strong>
          </Link>
          <span
            className="text-slate-700 font-semibold"
          >
            {report.store.city} - {report.store.state}
          </span>
          <time
            className="text-sm text-slate-500 mt-auto"
          >
            Atualizado {formatDateRelativeTime(report.updated_at)}
          </time>
        </div>
        <div className="flex items-end flex-col space-y-4">
          <div className="flex flex-col items-end space-y-2">
            {defineAlertBadges()}
          </div>
          <div className="flex space-x-2 ml-4">
            <Link to={`/reports/${report.id}`}>
              <Button
                type="button"
                size="icon"
                title="Detalhes"
              >
                <FaInfoCircle />
              </Button>
            </Link>
            <Button
              type="button"
              size="icon"
              title="Adicionar imagens"
              onClick={() => onAddImagesClick(report)}
              hasPermission={permissions.viewImages}
              disabled={permissions.isObserver}
              className="disabled:bg-slate-500"
            >
              <MdAddPhotoAlternate />
            </Button>
          </div>
        </div>
      </header>
      <div className="flex items-center justify-center w-full">
        <ImagesCarousel>
          {report.report_images.length > 0 &&
          report.report_images.map(image => (
            <img
              key={image.url}
              src={image.url}
              className="block h-full w-full m-auto object-cover object-center"
              loading="lazy"
            />
          ))}
        </ImagesCarousel>
      </div>
    </div>
  )
}
